export default "__VITE_ASSET__DSS0EBpJ__"